import * as React from 'react'

import { inject, observer } from 'mobx-react'

import WeatherForecastsStore from '~/client/src/shared/stores/domain/WeatherForecasts.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import WeatherUnits from '../../enums/WeatherUnits'
import { IWeatherBarForecast } from './WeatherBarPresenter'
import WeatherHourlyPresenter from './WeatherHourlyPresenter'

import './WeatherHourlyWidget.scss'

// localization: no display text to translate

const MIN_BAR_HEIGHT = 124
const MAX_BAR_HEIGHT = 160

interface IProps {
  startDate: number | Date
  startWithDate?: number | Date
  className?: string
  maxBarHeight?: number
  minBarHeight?: number

  iconSize?: number
  weatherForecastsStore?: WeatherForecastsStore
  projectDateStore?: ProjectDateStore
}

@inject('weatherForecastsStore', 'projectDateStore')
@observer
export default class WeatherHourlyWidget extends React.Component<IProps> {
  public render() {
    const {
      startDate,
      weatherForecastsStore,
      iconSize,
      className,
      maxBarHeight = MAX_BAR_HEIGHT,
      minBarHeight = MIN_BAR_HEIGHT,
    } = this.props

    const forecast = weatherForecastsStore.getHourlyForecastForDay(startDate)
    const units =
      weatherForecastsStore.weatherUnits === WeatherUnits.Imperial
        ? 'imperial'
        : 'metric'

    // Transform WeatherForecastInfo[] to presenter format
    const presenterForecasts: IWeatherBarForecast[] = forecast.map(f => ({
      time: f.date,
      temperature: f.currentTemp,
      weatherIconCode: f.weatherIconCode,
      windSpeed: f.windSpeed,
      windDegree: f.windDegree,
      probabilityOfPrecipitation: f.probabilityOfPrecipitation,
      amountOfPrecipitation: f.amountOfPrecipitation,
    }))

    return (
      <WeatherHourlyPresenter
        forecasts={presenterForecasts}
        units={units}
        formatTime={this.formatTime}
        iconSize={iconSize}
        maxBarHeight={maxBarHeight}
        minBarHeight={minBarHeight}
        className={className}
      />
    )
  }

  private formatTime = (timestamp: number): [string, string] => {
    const timeStr = this.props.projectDateStore.getTimeToDisplay(timestamp)
    const [time, format] = timeStr.split(' ')
    return [time, format || '']
  }
}
